<template>
    <v-layout>
        <v-content>
            <v-container fluid fill-height>
                <v-layout row wrap justify-center>
                    <v-flex xs10>
                        <h1 style="font-family: Lato; text-align: center; margin-left: 10px; margin-right: 10px;">
                            Transmutation
                        </h1>
                        <hr style="margin-bottom: 30px; margin-left: 10px; margin-right: 10px">
                    </v-flex>
                    <v-flex xs7>
                        <v-card>
                            <v-card-text>
                                <loading-component v-show="loadingPage"></loading-component>
                                <div v-show="!loadingPage">
                                    <v-form ref="form" v-model="valid" lazy-validation>
                                        <v-autocomplete ref="warehouse" :disabled="senderDisabled" :rules="[() => !!warehouse || 'This field is required']" :items="warehouses" v-model="warehouse" label="Warehouse location" placeholder="Select..." required outline v-on:change="selectWarehouse(warehouse)"></v-autocomplete>
                                    </v-form>
        
                                    <div v-if="warehouse && numbersAndNames">
                                        <v-layout column align-center justify-center>
                                            <recipeElement v-on:sliderChange="sliderChange" v-for="item in recipes" :key="item.id" :stocklist="fullStockList" :warehouseName="warehouse" :recipe-name="item.name" :recipe-description="item.description"></recipeElement>
                                        </v-layout>
        
                                        <div class="text-xs-center">
                                            <v-btn round color="secondary" dark @click="sendTransmutedItemsToBackend">Transmute</v-btn>
                                            <v-dialog
                                                v-model="dialog"
                                                max-width="400"
                                            >
                                                <v-card>
                                                    <v-card-title class="headline">Submission</v-card-title>
                                                    <v-card-text>
                                                        {{ dialogText }}
                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            color="primary"
                                                            flat="flat"
                                                            @click="dialog = false"
                                                        >
                                                            Close
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </div>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-layout>
</template>

<script>
const axios = require('axios')
import getSitePass from "../sitepass";
import loadingComponent from '../components/loadingSpinner.vue'
import recipeElement from '../components/stockTransmutation/recipeElement.vue'
import {
    recipeList
} from '../helpers/transmutationManager.js'

export default {
    components: {
        recipeElement,
        loadingComponent,
    },
    name: 'transmutation',
    data: function() {
        return {
            loadingPage: true,
            warehouses: [],
            fullStockList: [],
            senderDisabled: false,
            warehouse: undefined,
            disabledDetails: true,
            senderDisabled: false,
            numbersAndNames: null,
            recipes: recipeList,
            productionList:{},
            dialog: false,
            dialogText: "Please fill in the form",
        }
    },
    methods: {
        getAllStock() {
            axios
                .get(process.env.VUE_APP_backend_url + "/getWarehouseStockForMap", {
                    params: {
                        sitepass: getSitePass()
                    }
                })
                .then((response) => {
                    this.fullStockList = response.data;
                });
        },
        sliderChange(value){
            const recipe = value.recipe;
            const qty = value.value;

            this.productionList[recipe] = qty;
        },
        getWareHouses() {
            axios.get(process.env.VUE_APP_backend_url + '/getWarehouseNames', {
                    params: {
                        sitepass: getSitePass()
                    }
                })
                .then((response) => {
                    this.warehouses = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                }).
            finally(() => this.loadingPage = false);
        },
        selectWarehouse(company) {
            this.loadingPage = true;
            this.disabledItem = true;
            this.disabledDetails = true;
            this.senderDisabled = true;
            axios.get(process.env.VUE_APP_backend_url + '/getPartNameNum', {
                    params: {
                        sender: this.warehouse,
                        sitepass: getSitePass()
                    }
                })
                .then((response) => {
                    this.numbersAndNames = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                }).
            finally(() => {
                this.disabledItem = false;
                this.senderDisabled = false;
                this.loadingPage = false;
            });
        },
        sendTransmutedItemsToBackend() {
            // console.log(this.productionList)
            // need to validate the form first
            axios.post(process.env.VUE_APP_backend_url + '/stockTransmutation?sitepass=' + getSitePass(), {
                warehouse: this.warehouse,
                productionList: this.productionList,
            }).then((response) => {
                this.dialogText = response.status = 200
                    ? "This form has been successfully submitted"
                    : "Sorry, there has been a problem proccessing you request"
            })
            .catch((error) => {
                this.dialogText = "Sorry, there has been a problem proccessing you request"
                console.log(error)
            })
            .finally(() => {
                this.dialog=true
            });
        }
    },
    created() {
        this.getWareHouses();
        this.getAllStock();
    }

}
</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/views/stockTransmutationView.vue